const Graph = require('./BaseGraph')

module.exports = class WebsiteGraph extends Graph 
{
    constructor(apiDomain, path="website")
    {
        super(apiDomain, path)
    }
    
    webpageQuery(fields, params=null)
    {
        if (params)
            return { type: 'webpage', query: this.queryString('webpage', fields, params) }

        return { type: 'webpage', query: `query getWebpage ($url: String!) {
            webpage(url: $url)
            ${this.queryFields(fields)}
        }` }
    }

    pageLayoutQuery(fields, params=null)
    {
        if (params)
            return { type: 'pageLayout', query: this.queryString('pageLayout', fields, params) }

        return { type: 'pageLayout', query: `query getPageLayout ($url: String!) {
            pageLayout(url: $url)
            ${this.queryFields(fields)}
        }`}
    }

    pageContentQuery(fields, params=null)
    {
        if (params)
            return { type: 'pageContent', query: this.queryString('pageContent', fields, params) }

        return { type: 'pageContent', query: `query getPageContent ($url: String!) {
            pageContent(url: $url)
            ${this.queryFields(fields)}
        }` }
    }

    sitesQuery(fields, params=null)
    {
        if (params)
            return { type: 'sites', query: this.queryString('sites', fields, params) }

        return { type: 'sites', query: `query getSites ($accountId: String!, $codes: [String]) {
            sites(accountId: $accountId, codes: $codes)
            ${this.queryFields(fields)}
        }` }
    }

    siteQuery(fields, params=null)
    {
        if (params)
            return { type: 'site', query: this.queryString('site', fields, params) }

        return { type: 'site', query: `query getSite ($accountId: String!, $code: String!) {
            site(accountId: $accountId, code: $code)
            ${this.queryFields(fields)}
        }` }
    }

    bannersQuery(fields, params=null)
    {
        if (params)
            return { type: 'banners', query: this.queryString('banners', fields, params)}

        return { type: 'banners', query: `query getBanners ($websiteId: String) {
            banners(websiteId: $websiteId)
            ${this.queryFields(fields)}
        }` }
    }

    stylesQuery(fields, params=null)
    {
        if (params)
            return { type: 'styles', query: this.queryString('styles', fields, params)}

        return { type: 'styles', query: `query getStyles ($websiteId: String) {
            styles(websiteId: $websiteId)
            ${this.queryFields(fields)}
        }` }
    }

    navigationQuery(fields, params=null)
    {
        if (params)
            return { type: 'navigation', query: this.queryString('navigation', fields, params) }

        return { type: 'navigation', query: `query getNavigation ($websiteId: String!) {
            navigation(websiteId: $websiteId)
            ${this.queryFields(fields)}
        }` }
    }

    sectionsQuery(fields, params=null)
    {
        if (params)
            return { type: 'sections', query: this.queryString('sections', fields, params) }

        return { type: 'sections', query: `query getSections ($websiteId: String!, $page_id: ID!) {
            sections(websiteId: $websiteId, page_id: $page_id)
            ${this.queryFields(fields)}
        }` }
    }

    saveCustomizationMutation(fields, params=null)
    {
        if (params)
            return { type: 'customization', query: `mutation {
                customContent(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'customization', query: `mutation customize ($websiteId: String!, $content: String, $theme: String, $page: String, $navigation: String, $files: [Upload]) {
            customize(websiteId: $websiteId, content: $content, theme: $theme, page: $page, navigation: $navigation, files: $files)
            ${this.queryFields(fields)}
        }` }
    }

    resetMutation(fields, params=null)
    {
        if (params)
            return { type: 'reset', query: `mutation {
                reset(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'reset', query: `mutation reset ($websiteId: String!) {
            reset(websiteId: $websiteId)
            ${this.queryFields(fields)}
        }` }
    }

    resetPageMutation(fields, params=null)
    {
        if (params)
            return { type: 'resetPage', query: `mutation {
                resetPage(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'resetPage', query: `mutation resetPage ($websiteId: String!, $page_id: ID!) {
            resetPage(websiteId: $websiteId, page_id: $page_id)
            ${this.queryFields(fields)}
        }` }
    }

    customLinkMutation(fields, params=null)
    {
        if (params)
            return { type: 'customLink', query: `mutation {
                customLink(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'customLink', query: `mutation customLink ($websiteId: String!, $label: String!, $link: String!) {
            customLink(websiteId: $websiteId, label: $label, link: $link)
            ${this.queryFields(fields)}
        }` }
    }

    removeFileMutation(fields, params=null)
    {
        if (params)
            return { type: 'removeFile', query: `mutation {
                removeFile(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return {
            type: 'removeFile', query: `mutation removeFile ($websiteId: String!, $block: String!, $item: String!) {
            removeFile(websiteId: $websiteId, block: $block, item: $item)
            ${this.queryFields(fields)}
        }` }
    }
}